import { render, staticRenderFns } from "./AccountWishlist.vue?vue&type=template&id=63924712&scoped=true&"
import script from "./AccountWishlist.vue?vue&type=script&lang=js&"
export * from "./AccountWishlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63924712",
  null
  
)

export default component.exports